// tslint:disable:jsx-no-multiline-js
import { Button, Icon } from '@abb/common-ux';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './CustomerSiteModal.scss';

interface ICustomerSiteModalProps {
    isOpen: boolean;
    servIsSite: any;
    onClose: () => void;
    onContinue: () => void;
}

export class CustomerSiteModal extends React.Component<ICustomerSiteModalProps, any> {
    constructor(props: ICustomerSiteModalProps) {
        super(props);
    }

    render() {
        const body = this.props.servIsSite ? (
            <div>
                <div className='row'>
                    <div className='col-xs-6 vertical-padding' >
                        <div className='col-xs-5 bold'>Site:</div>
                        <div className='col-xs-7'>{this.props.servIsSite.siteName ? this.props.servIsSite.siteName : ''}</div>
                    </div>
                    <div className='col-xs-6 vertical-padding' >
                        <div className='col-xs-5 bold'>Owner:</div>
                        <div className='col-xs-7'>{this.props.servIsSite.owner ? this.props.servIsSite.owner : ''}</div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-6 vertical-padding' >
                        <div className='col-xs-5 bold'>ServIS ID:</div>
                        <div className='col-xs-7'>{this.props.servIsSite.servIsId ? this.props.servIsSite.servIsId : ''}</div>
                    </div>
                    <div className='col-xs-6 vertical-padding' >
                        <div className='col-xs-5 bold'>Operator:</div>
                        <div className='col-xs-7'>{this.props.servIsSite.operator ? this.props.servIsSite.operator : ''}</div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-6 vertical-padding' >
                        <div className='col-xs-5 bold'>City:</div>
                        <div className='col-xs-7'>{this.props.servIsSite.city ? this.props.servIsSite.city : ''}</div>
                    </div>
                    <div className='col-xs-6 vertical-padding' >
                        <div className='col-xs-5 bold'>Country:</div>
                        <div className='col-xs-7'>{this.props.servIsSite.country ? this.props.servIsSite.country : ''}</div>
                    </div>
                </div>
                <div style={{ borderBottom: '1px solid #e5e5e5' }} className='row'>
                    <div className='col-xs-6 vertical-padding' >
                        <div className='col-xs-5 bold'>Region:</div>
                        <div className='col-xs-7'>{this.props.servIsSite.regionName ? this.props.servIsSite.regionName : ''}</div>
                    </div>
                </div>
            </div>
        ) : (
            <div>
                <div className='row col-xs-12'>
                Loading...
                </div>
            </div>
        );
        const modal = (
            <div className='modal-window'>
             <div className='modal-overlay'>
               <div className='modal-outer'>
                 <div className='modal-inner'>
                   <div className='table'>
                     <div className='row bottom-border'>
                       <div className='col-xs-10'><h4>Do You Want To Update Site Information?</h4></div>
                       <div className='col-xs-2 text-right'>
                         <span className='close-icon font-12' onClick={this.props.onClose}><Icon icon='close'/></span>
                       </div>
                     </div>
                   </div>
                    {body}
                    <div style={{ marginTop: '15px' }} className='text-right'>
                        <Button buttonType='normal' buttonSize='default' onClick={this.props.onClose}>Cancel</Button>
                        <Button style={{ marginLeft: '5px' }} buttonType='primary' buttonSize='default' onClick={this.props.onContinue}>Continue</Button>
                    </div>
                 </div>
               </div>
             </div>
           </div>
         );
        return (
            this.props.isOpen ? modal : null
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/SiteLicense/CustomerSiteModal.tsx